import { IPaginationRequest } from "interfaces/pagination";
import axios from "axios";

const CCKBayService = axios.create({
  baseURL: `${process.env.REACT_APP_API}/cck-bay`,
});

const CCKBayServices = {
  getDetail: (token: string, id: string) =>
    CCKBayService.get(`/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }),
  getAllActive: (token: string, booking_date: string) =>
    CCKBayService.get(`active?bookingDate=${booking_date}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }),
  getAll: (token: string, pagination: IPaginationRequest) =>
    CCKBayService.get(
      `list?perPage=${pagination.per_page}&page=${pagination.page}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    ),
  create: (
    token: string,
    data: {
      bay_number: number;
      name: string;
    }
  ) =>
    CCKBayService.post(`/create`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }),
  edit: (
    token: string,
    id: string | number,
    data: {
      bay_number: number;
      name: string;
    }
  ) =>
    CCKBayService.put(`/${id}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }),
  delete: (token: string, id: string | number) =>
    CCKBayService.delete(`/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }),
  changeStatus: (
    token: string,
    id: string | number,
    data: {
      status: boolean;
    }
  ) =>
    CCKBayService.put(`/${id}/status`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }),
  addCloseDate: (
    token: string,
    id: string | number,
    data: {
      close_date: string;
    }
  ) =>
    CCKBayService.post(`/${id}/close/add`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }),
  cancelCloseDate: (
    token: string,
    id: string | number,
    close_date_id: number
  ) =>
    CCKBayService.delete(`/${id}/close/${close_date_id}/cancel`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }),
};

export default CCKBayServices;
